import { useState } from "react";
import { Outlet, NavLink } from "react-router-dom";
import Topbar from "./Topbar";
import NewFooter from "./NewFooter";

const Layout = () => {
  const [menuVisible, setMenuVisible] = useState(false);

  const toggleMenu = () => {
    setMenuVisible((prev) => !prev);
  };

  return (
    <>
    <div className="fixedtop">
      <Topbar onToggleMenu={toggleMenu} />
      <nav>
        <div
          className={`nav-elements bg-primary text-white ${menuVisible ? "block" : "hidden lg:block"} border-tb gap-6 p-2`}
        >
          <ul className="flex p-0 m-0 gap-2 flex-column lg:flex-row lg:gap-6 lg:px-5">
            {['/', '/about', '/solutions', '/contact'].map((path, index) => (
              <li key={index}>
                <NavLink 
                  to={path} 
                  className={({ isActive }) => isActive ? "text-yellow-400" : "text-white"} 
                  onClick={() => setMenuVisible(false)}
                >
                  {path === '/' ? 'Home' : path.slice(1).charAt(0).toUpperCase() + path.slice(2)}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </nav>
      </div>
      <div className="overflow-auto border-gold container-ara ">
        <Outlet />
      </div>

      <NewFooter />
    </>
  );
};

export default Layout;
